import React, { useEffect } from "react";
import "./index.scss";
import { Col, Row, Typography, Table } from "antd";
import { useTranslation } from "react-i18next";
const { Title, Paragraph, Link, Text } = Typography;

const QuestionsPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("title.questions");
  }, [t]);

  const data = [
    {
      package: "DIARIA",
      fee: "S/ 1.80",
      bid: "2",
      duration: "1 día",
    },
    {
      package: "SEMANAL",
      fee: "S/ 3.99",
      bid: "5",
      duration: "7 días",
    },
    {
      package: "MENSUAL",
      fee: "S/ 6.99",
      bid: "20",
      duration: "30 días",
    },
  ];
  const columns = [
    {
      title: "Tipo de Suscripción",
      dataIndex: "package",
    },
    {
      title: "Precio (inc. IGV)",
      dataIndex: "fee",
    },
    {
      title: "Cantidad de Pujas",
      dataIndex: "bid",
    },
    {
      title: "Vigencia",
      dataIndex: "duration",
    },
  ];

  return (
    <div className="rules-page">
      <div className="rules-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            <Title level={2} className="rules-page-title">
              {t("questions")}
            </Title>

            <div className="rules-page-content">
              <Typography>
                <Title level={2}>
                  <u>¿Qué es Subastas?</u>
                </Title>
                <Paragraph>
                  El servicio subastas es un juego interactivo diseñado e
                  inspirado en los programas de subastas donde el cliente con la
                  oferta/puja* con el precio más bajo, único y válido gana el
                  premio.
                </Paragraph>
                <Paragraph>
                  <Text type="danger">*</Text>Cantidad de dinero que un
                  individuo está dispuesto a ofrecer por la adquisición de un
                  bien o servicio en particular.
                </Paragraph>
                <Title level={2}>
                  <u>¿Cómo me puedo suscribir?</u>
                </Title>

                <Paragraph>
                  El cliente puede suscribirse de dos maneras:{" "}
                </Paragraph>
                <Paragraph>
                  1) Vía SMS: Enviando la palabra “SUBASTA” para la suscripción
                  diaria, “SUBASTA7” para la suscripción semanal y “SUBASTA30”
                  para la suscripción mensual al 23001.
                </Paragraph>
                <Paragraph>
                  2) Vía web desde el siguiente enlace web{" "}
                  <Link href="https://subasta.bitel.com.pe/" underline>
                    https://subasta.bitel.com.pe
                  </Link>{" "}
                  y seguir las instrucciones. Luego de registrarse, el cliente
                  deberá iniciar sesión y dirigirse a la parte izquierda
                  inferior donde figura su número Bitel y darle “click”. Luego
                  de ello, deberá ir a sección “Suscripción” y elegir la
                  suscripción de su preferencia: Diaria, Semanal o Mensual. El
                  cliente recibirá un USSD mediante el celular deberá confirmar
                  su suscripción.
                </Paragraph>
                <Title level={2}>
                  <u> ¿Cuánto cuesta? </u>
                </Title>
                <Table
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  scroll={{ x: true }}
                  bordered
                />
                <Paragraph>
                  <br />
                  El servicio se renovará automáticamente de acuerdo a la
                  modalidad de suscripción elegida por el cliente. Este valor se
                  descontará del saldo básico (recargas) que tenga el usuario.
                </Paragraph>
                <Title level={2}>
                  <u>¿Cómo puedo jugar?</u>
                </Title>
                <Paragraph>Hay dos formas de colocar la puja/oferta:</Paragraph>
                <Paragraph>
                  1) Vía SMS: Para poder colocar la puja/oferta vía SMS, el
                  cliente deberá enviar un mensaje de texto al 23001 con las
                  palabras “S [Precio de oferta]”. Ejemplo: S 10, siendo 10 el
                  precio de oferta. El código de producto será informado al
                  cliente mediante SMS (siempre que la suscripción se haya
                  realizado vía SMS).
                </Paragraph>
                <Paragraph>
                  2) Vía web desde el siguiente enlace web{" "}
                  <Link href="https://subasta.bitel.com.pe/" underline>
                    https://subasta.bitel.com.pe
                  </Link>{" "}
                  Para poder colocar la puja/oferta vía web, el cliente deberá
                  iniciar sesión y dirigirse a la sección “Haz tu oferta más
                  baja y única aquí” y luego escribir el valor de la puja y
                  luego dar “click” en “Coloca la oferta/puja más baja que creas
                  conveniente”.
                </Paragraph>
                <Title level={2}>
                  <u>¿Cuál es el premio?</u>
                </Title>
                <Paragraph>
                  El premio a ser entregado al ganador será el mismo por el que
                  este ofertó/pujó durante el ciclo de subasta del producto.
                </Paragraph>
                <Title level={2}>
                  <u>¿Cómo sé si gané?</u>
                </Title>
                <Paragraph>
                  El ganador será contactado y confirmado al final del ciclo de
                  subasta. Esta comunicación se realizará vía SMS. En ese SMS se
                  le indicará que es el ganador de la subasta y se le informará
                  que el 123 (Centro de Atención al Cliente de Bitel) se estará
                  comunicando con él/ella.
                </Paragraph>
                <Title level={2}>
                  <u>¿Cómo sé quién ganó?</u>
                </Title>
                <Paragraph>
                  Los clientes podrán ver quién ha sido el ganador de la Subasta
                  vía web{" "}
                  <Link href="https://subasta.bitel.com.pe/" underline>
                    https://subasta.bitel.com.pe
                  </Link>{" "}
                  en la sección “Resultados” o vía SMS enviando un mensaje al
                  23001 que diga: palabra GANADOR [Código del Producto].
                </Paragraph>
                <Title level={2}>
                  {" "}
                  <u>¿Cómo puedo reclamar mi premio si soy el ganador?</u>
                </Title>
                <Paragraph>
                  Una vez el ganador sea contactado por el Centro de Atención al
                  Cliente de Bitel se le dará el premio según los siguientes
                  casos:
                </Paragraph>
                <Paragraph>
                  - En caso el ganador resida en Lima y Callao: El premio será
                  entregado en la sede de Bitel, ubicada en Calle 21 N° 878 Urb.
                  Córpac, distrito de San Isidro.
                </Paragraph>
                <Paragraph>
                  - En caso el ganador resida en provincia: El premio será
                  entregado en un Centro de Atención Bitel, previa coordinación
                  con el ganador.
                </Paragraph>
                <Title level={2}>
                  <u>¿Cómo cancelo el servicio?</u>
                </Title>
                <Paragraph>
                  El usuario podrá cancelar su suscripción en el momento que
                  desee. Para cancelar el Servicio, deberá enviar la palabra
                  “SALIR” al 23001.
                </Paragraph>
              </Typography>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default QuestionsPage;
